<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span>Cuenta contable</span>
  <button mat-icon-button (click)="dialogRef.close()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content style="padding:16px 24px">
  <ng-container *ngIf="ready">
    <convfact-accountingAccounts-form
      [accountingAccounts]="accountingAccounts"
      *ngIf="accountingAccounts"
      [errors]="errors"
      (onSave)="saveData($event)">
    </convfact-accountingAccounts-form>
  </ng-container>
  <ng-container *ngIf="!ready">
    <div class="cf-dlg-loading">
      <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
      <p class="cf-dlg-loading__text">Cargando...</p>
    </div>
  </ng-container>
</mat-dialog-content>
